module.exports = "## Menu\n[Menus](https://www.google.com/design/spec/components/menus.html) allow you to\ntake an action by selecting from a list revealed upon opening a temporary,\nnew sheet of material.\n\nA `Menu` is typically used in a [Popover](/#/components/popover).\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/Menu/README.md
 ** module id = 1021
 ** module chunks = 0
 **/